import { openBlock as o, createElementBlock as r, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return o(), r("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.667 14.5c0-.46.355-.833.794-.833h5.078c.438 0 .794.373.794.833s-.356.833-.794.833H9.46c-.439 0-.794-.373-.794-.833",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m20 10.5-8-6-8 6V20h16zM12 2l10 7.5V22H2V9.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const i = { render: t };
export {
  i as default,
  t as render
};
